<template>
  <div class="m-report-btn">
    <el-popover placement="bottom" width="300" popper-class="report-box" v-model="visible">
      <p class="summary text-overflow">{{ info.name }} : {{ info.txt }}</p>
      <el-input style="margin-bottom: 10px" type="textarea" :autosize="{ minRows: 4, maxRows: 6 }" v-model="txt" placeholder="请输入举报内容"></el-input>
      <div class="bottom">
        <span :style="{ color: this.flag ? '#67C23A' : '#F56C6C' }">{{ tipTxt }}</span>
        <div style="text-align: right;">
          <el-button type="text" @click="visible = false">取消</el-button>
          <el-button type="primary" @click="sendReport">确定</el-button>
        </div>
      </div>

      <svg-icon slot="reference" title="举报" @click="visible = true" name="warning"></svg-icon>
    </el-popover>
  </div>
</template>
<script>
import Chat from "@/api/chat";
export default {
  data() {
    return {
      txt: "",
      tipTxt: "",
      visible: false,
      flag: true
    };
  },
  methods: {
    async sendReport() {
      if (!this.txt) {
        this.tipTxt = "举报内容不能为空！";
        this.flag = false;
      } else {
        this.flag = true;
      }
      if (this.flag) {
        await Chat.report({ msgId: this.info.msgId, detail: this.txt });
        this.tipTxt = "发送成功！请等待审核";
      }
      setTimeout(() => {
        this.tipTxt = "";
        if (this.flag) {
          this.txt = "";
          this.visible = false;
        }
      }, 3000);
    }
  },
  props: {
    info: Object
  }
};
</script>
<style lang="scss">
.m-report-btn {
  display: inline;
}
.report-box {
  .bottom {
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .el-button + .el-button {
      margin-left: 16px;
    }
    .el-button--primary {
      padding: 12px 30px;
    }
  }
  .summary {
    padding: 4px;
    background-color: #f0f0f0;
    border-radius: 2px;
    margin-bottom: 8px;
  }
}
</style>
